import {
  CANCEL_REGISTRATION,
  CHECK_IDNTY_GOOGLE_ACCOUNT_START,
  CHECK_IDNTY_GOOGLE_ACCOUNT_FULFILLED,
  CHECK_IDNTY_GOOGLE_ACCOUNT_REJECTED,
  REGISTER_EXISTING_USER_START,
  REGISTER_EXISTING_USER_FULFILLED,
  REGISTER_EXISTING_USER_REJECTED,
  REGISTER_USER_START,
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  SET_SUBMITTING,
  SUBMIT_EASY_JOIN_CODE_START,
  SUBMIT_EASY_JOIN_CODE_FULFILLED,
  SUBMIT_EASY_JOIN_CODE_REJECTED,
} from './actionTypes';

const initialState = {
  isComplete: false,
  isEasyJoinLoading: false,
  isJoinComplete: false,
  isRegistrationLoading: false,
  isSubmitting: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CANCEL_REGISTRATION: {
      return {
        ...state,
        isComplete: false,
        isEasyJoinLoading: false,
        isJoinComplete: false,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case REGISTER_USER_START: {
      return {
        ...state,
        isRegistrationLoading: true,
        isSubmitting: true,
      };
    }
    case REGISTER_USER_FULFILLED: {
      return {
        ...state,
        isComplete: true,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case REGISTER_USER_REJECTED: {
      return {
        ...state,
        isRegistrationLoading: false,
        isSubmitting: false,
      };
    }
    case REGISTER_EXISTING_USER_START:
    case CHECK_IDNTY_GOOGLE_ACCOUNT_START: {
      return {
        ...state,
        isSubmitting: true,
      };
    }
    // isJoinComplete (not isComplete) - RegistrationContainer's redirect
    // effect watches isComplete and would race the explicit, userType-aware
    // history.push already done by IdntyRegistrationForm's handleSignIn/
    // handleConfirmGoogleJoin, silently dropping the ?userType= param. This
    // flag only drives RegistrationFormWrapper's fade-out animation.
    case REGISTER_EXISTING_USER_FULFILLED: {
      return {
        ...state,
        isJoinComplete: true,
        isSubmitting: false,
      };
    }
    // Deliberately does NOT set isComplete or isJoinComplete - this fires for
    // outcomes (ALREADY_MEMBER, NEW_USER) that never join anything. Setting
    // isComplete here would wrongly trigger RegistrationContainer's
    // isComplete-driven redirect-to-success effect while a NEW_USER is still
    // filling out the registration form.
    case REGISTER_EXISTING_USER_REJECTED:
    case CHECK_IDNTY_GOOGLE_ACCOUNT_FULFILLED:
    case CHECK_IDNTY_GOOGLE_ACCOUNT_REJECTED: {
      return {
        ...state,
        isSubmitting: false,
      };
    }
    case SET_SUBMITTING: {
      return {
        ...state,
        isSubmitting: action.payload,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_START: {
      return {
        ...state,
        isEasyJoinLoading: true,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_FULFILLED: {
      return {
        ...state,
        isEasyJoinLoading: false,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_REJECTED: {
      return {
        ...state,
        isEasyJoinLoading: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
